<template>
  <div>
    <v-container>
        <div v-if="!CursosAdmin.length" class="dataDef">Seleccione un estudiante para ver información de sus cursos</div>
        <v-row v-else>
          <v-col
            v-for="item in CursosAdmin"
            :key="item.id"
            cols="12"
            md="4"
          >
            <v-card class="course-card">
              <!-- <v-img
                :src="courses[0].image"
                height="200"
              ></v-img> -->
            <!-- comienza gaaa -->
            <v-list-item>
              <v-list-item-avatar
                class="ml-0 mr-1"
                size="50"
                color="item.color_curso"
              >
                <v-icon dark>{{ item.icono_curso }}</v-icon>
              </v-list-item-avatar>

                      <v-list-item-content class="py-0">
                        <span class="mb-1 font-weight-bold black--text">{{
                          item.desc_curso
                        }}</span>
                        <v-list-item-title class="caption"
                          >Área: {{ item.desc_area }}</v-list-item-title
                        >
                      </v-list-item-content>
                </v-list-item>
                <v-card-text
                      :style="{ background: item.color_nivel }"
                      id="text"
                      >{{ item.nivel }} - {{ item.grado }}</v-card-text
                    >
              <v-card-text>{{ item.description }}</v-card-text>
              <v-card-actions>
                <!-- <v-btn color="primary" @click="enroll(item.id)">Enroll</v-btn> -->
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        
      </v-container>
    </div>
  </template>


<script>
import axios from "@/helpers/axios";

export default {
  name: "MisCursos",
  components: {},
  props: ["Cursos", "ElEstudiante", "selectedAlumno"],

  data() {
    return {
      CursosAdmin: [],
      //   mostrarMensaje2,
    };
  },
  // watcher:{
  //   CursosAdmin:[],
  // },
  methods: {
    

    async getAllCursosAdministrativo() {
      // this.mostrarMensaje2 = false;
      // this.mostrarMensaje = false;
      if (!this.ElEstudiante.id_nivel || !this.ElEstudiante.id_grado)
        return console.log("it needs id_grado and id_nivel");

      let params = {
        id_colegio: sessionStorage.id_colegio,
        id_anio_lectivo: sessionStorage.id_ano_lectivo,
        id_nivel: this.ElEstudiante.id_nivel_mant,
        id_grado: this.ElEstudiante.id_grado_mant,
      };
      // console.log(this.ElEstudiante, "ElEstudiante");

      try {
        // this.CursosAdmin = []
        let response = await axios.post(
          "/administrativo/curso/adm/list/",
          params
        );
        this.CursosAdmin = response.data;
        // console.log("====>>", this.CursosAdmin);

        if (this.CursosAdmin.length === 0) {
          //   this.mostrarMensaje2 = true;
        }

        if (this.Cursos.length === 0 && this.CursosAdmin.length === 0) {
          //   this.mostrarMensaje = true;
        }
      } catch (error) {
        // this.setEnviarMens({ tipo: "E", mensaje: error, tiempo: null });
        console.log(error, "hahahay");
        this.CursosAdmin = []
      }
    },

    limpiarCursos() {
      this.CursosAdmin = [];
      // this.ElEstudiante = {};
    },
  },

  mounted() {
    // this.mostrarMensaje2 = true;
    this.getAllCursosAdministrativo();
  },

  watch: {
    ElEstudiante() {
      this.getAllCursosAdministrativo();
      // console.log(newValue, "1354aaa");
      if (!this.selectedAlumno) {
        // console.log(!this.selectedAlumno, "vavavaa");
        // this.CursosAdmin = [];
        this.limpiarCursos();
      }
    },
    // selectedAlumno(newValue, oldValue) {
    //   this.getAllCursosAdministrativo();
    //   if (!this.selectedAlumno) {
    //     console.log(!this.selectedAlumno, "agasgsbbb");
    //     // this.CursosAdmin = [];
    //     this.limpiarCursos();
    //   }
    // },
  },
};
</script>

<style>
.course-card {
  margin-bottom: 20px;
}

.dataDef {
  color: red;
  margin-bottom: 20px;
  height: 150px;
  width: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 15px;
  background-color: rgb(228, 228, 228) !important;
  font-size: 18px;
  font-weight: 600px;

}
</style>